import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

import { FormFieldConfig } from '../dropdown/form_field_config';
import { DatePipe } from '@angular/common';
import { FormControl } from '@angular/forms';
import { UserService } from 'src/app/admin/core/services/user.service';

@Component({
    selector: 'app-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.css'],
})
export class DateComponent implements OnInit {
    @Input() config: FormFieldConfig;
    @Input() data: any;
    editMode: boolean = false;
    selectedDate: any;
    formattedDate: any;
    displayDate: string | null = null; // Formatted date for display (DD/MM/YYYY)
    selectedDateControl: FormControl = new FormControl();
    typeName: any;

    constructor(private datePipe: DatePipe, public userService: UserService) {}

    ngOnInit(): void {
        this.setVisibility();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['config']) {
            this.config = changes['config'].currentValue;
            this.typeName = this.config.typeName;
            this.editMode = this.config.editMode;

            if (this.config.value) {
                try {
                    const dateValue = new Date(this.config.value);
                    this.displayDate = this.datePipe.transform(dateValue, 'dd/MM/yyyy');
                    this.formatToDatePicker(this.config?.value);
                } catch {
                    this.config.value = this.config.value.filter((el: any, i: number) => i < 3);
                    const dateValue = new Date(this.config?.value.join('-'));
                    this.displayDate = this.datePipe.transform(dateValue, 'dd/MM/yyyy');
                    this.formatToDatePicker(this.config?.value);
                }
            } else {
                // Clear displayDate if config.value is null/undefined
                this.displayDate = null;
                this.formatToDatePicker(null);
            }
        }
    }

    ngAfterViewInit() {
        this.formatToDatePicker(this.config?.value);
    }

    setVisibility() {
        if (!this.config.isDynamic) {
            this.config.isVisible = true;
            this.config.isModifiable = true;
        }
    }

    formatToDatePicker(dateString: any): any {
        let formattedDate: string | null;

        if (dateString) {
            formattedDate = this.datePipe.transform(dateString, 'yyyy-MM-dd');
            // Update displayDate for view mode (DD/MM/YYYY format) only if not already set
            if (!this.displayDate) {
                this.displayDate = this.datePipe.transform(dateString, 'dd/MM/yyyy');
            }
        } else {
            formattedDate = null;
            this.displayDate = null;
        }

        if (formattedDate) {
            this.selectedDateControl.setValue(formattedDate);

            if (!this.config.isModifiable) this.selectedDateControl.disable();
            this.selectedDate = formattedDate;
        } else {
            this.selectedDateControl.setValue(null); // Ensure the input is cleared
            this.selectedDate = null;
            this.displayDate = null;
        }
    }

    formatDate(dateString: any): any {
        return dateString ? new Date(dateString).toISOString().substring(0, 19) : null;
    }
}
